var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row mt-5 section"},_vm._l((_vm.exhibitions),function(exh){return _c('EntityCard',{key:("exhibition-" + (exh.id)),staticClass:"col-12 col-md-6 col-lg-4",attrs:{"data":exh,"data-aos":"fade-up","type":"exhibitions"}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }